import { render, staticRenderFns } from "./shiftsInDialog.vue?vue&type=template&id=5f5e1557"
import script from "./shiftsInDialog.vue?vue&type=script&lang=ts"
export * from "./shiftsInDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports